import React, { useEffect } from "react";
import HeroSection from "../components/Home/HeroSection";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import Products from "../components/Home/Products"
import CarePillars from "../components/Home/CarePillars";
import BeautyIntro from "../components/Home/BeautyIntro";
import Memberships from "../components/Home/Memberships"
import Account from "../components/Home/Account";
import BodySculptPremium from "../components/Home/BodySculptPremium";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSection />
      <CarePillars />
      <BeautyIntro />
      <Products />
      <WhyChooseUs />
      <Memberships />
      <BodySculptPremium />
      <Account />
    </>
  );
};

export default Home;